import { Component } from "react";
import { connect } from "react-redux";
import { addSettings } from "../../../actions";
import Agreement from "../../../components/Reseller/agreement_new";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import { THEME_COLOR } from "./../../../config/config";

// Unsigned (optional / not-required) agreements page for resellers/partners.
// Thin wrapper around the shared <Agreement> component so this view gets the
// full signing experience (review & verify stepper, once-only "I confirm",
// signature carry-forward, fullscreen reader, jump-to-bottom, download,
// multi-document carousel) from a single source of truth.
class Agreements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allSigned: false,
    };
  }

  // Called by <Agreement> when there are no unsigned agreements left
  // (either on load or after the last one is signed).
  handleAllSigned = () => {
    this.setState({ allSigned: true });
    // Embedded in the Agreements page tabs: flip over to the Signed tab
    if (this.props.switchToSignedTab) {
      this.props.switchToSignedTab();
    }
  };

  renderBody() {
    if (this.state.allSigned) {
      return (
        <div className="card card-bordered" style={{ border: "none" }}>
          <div
            className="card-inner"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "60px 20px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: "64px",
                height: "64px",
                borderRadius: "50%",
                backgroundColor: `${THEME_COLOR}14`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "16px",
              }}
            >
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={THEME_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
            </div>
            <h5 style={{ fontWeight: 700, color: "#364a63", marginBottom: "6px" }}>
              All agreements signed
            </h5>
            <p style={{ fontSize: "13px", color: "#8094ae", margin: 0 }}>
              You have no pending agreements to sign.
            </p>
          </div>
        </div>
      );
    }
    return (
      <Agreement
        agreementsType="not_required"
        keepSidebar={true}
        agreementSigned={this.handleAllSigned}
        backgroundColor={this.props.backgroundColor}
      />
    );
  }

  render() {
    // Embedded inside the Agreements page tabs (index.js passes
    // switchToSignedTab): the host page already provides the page chrome
    // (title, warnings, layout), so render only the body.
    if (this.props.switchToSignedTab) {
      return this.renderBody();
    }
    return (
      <div className="nk-content unsignedagreements" id="Services_Block">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}
          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between-md g-3">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      Agreement Signing
                    </h3>
                    <div className="nk-block-des text-soft">
                      <p>Review and sign your pending agreements</p>
                    </div>
                  </div>
                </div>
              </div>
              {/* PAGE TITLE END */}
              <div className="nk-block">{this.renderBody()}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Agreements);
